import { render, staticRenderFns } from "./MachineryAtlas.vue?vue&type=template&id=1bf052e8&scoped=true&"
import script from "./MachineryAtlas.vue?vue&type=script&lang=js&"
export * from "./MachineryAtlas.vue?vue&type=script&lang=js&"
import style0 from "./MachineryAtlas.vue?vue&type=style&index=0&id=1bf052e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf052e8",
  null
  
)

export default component.exports